// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"69d1572b","238":"30eb0466","453":"e0710aa5","524":"bf906635","548":"40fff42d","555":"40fea9f3","916":"3cdb7611"}[chunkId] + ".chunk.js";
};